<template>
  <div>
    <b-form-input @keydown="clean($event)" @keyup="onkeyup($event)" :value="input_value" :state="state"></b-form-input>
    <slot></slot>
  </div>
</template>

<script>
    export default {
        created() {
            this.input_value = this.value;
        },
        data: () => {
            const ascii_zero = '0'.charCodeAt(0);
            return {
                arrow_keys: [37, 38, 39, 40],
                delete_keys: [8, 46],
                ctrl_key: 17,
                ctrl_pressed: false,
                v_key: 86,
                c_key: 67,
                a_key: 65,
                ascii_zero: ascii_zero,
                ascii_numeric_zero: 96,
                input_value: null,
            }
        },
        methods: {
            clean(event) {
                const key = event.keyCode || event.which;
                //console.log(key);

                if (key === this.ctrl_key) {
                    this.ctrl_pressed = true;
                    return;
                }

                if (this.arrow_keys.indexOf(key) !== -1) return;
                if (this.delete_keys.indexOf(key) !== -1) return;
                if (this.ctrl_pressed && key === this.v_key) return;
                if (this.ctrl_pressed && key === this.c_key) return;
                if (this.ctrl_pressed && key === this.a_key) return;

                if (!this.is_numeric_key(key)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            },
            format(value) {
                this.input_value = value.replace(/\./g, '').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
            },
            onkeyup(event) {
                const key = event.keyCode || event.which;

                if (key === this.ctrl_key) this.ctrl_pressed = false;
                if (this.arrow_keys.indexOf(key) !== -1) return;

                this.format(event.target.value);
                this.$emit("input", this.input_value);
            },
            is_numeric_key(key) {
                return (key - this.ascii_zero >= 0 && key - this.ascii_zero <= 9) ||
                    (key - this.ascii_numeric_zero >= 0 && key - this.ascii_numeric_zero <= 9)
            }
        },
        watch: {
            value(new_value) {
                this.format(new_value);
            }
        },
        props: {
            "value": String,
            "state": Boolean
        }
    }
</script>
